export const FormSubmissionStatus = {
  VALIDATED: "validated",
  INVALIDATED: "invalidated",
  PENDING: "pending",
  SUBMITTED: "submitted",
  DRAFT: "draft",
} as const;
export type FormSubmissionStatusType =
  (typeof FormSubmissionStatus)[keyof typeof FormSubmissionStatus];
